module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_waso_studio-1bddeb583e424452e87d4e415ba57350.webp";